@use "Styles/mixins" as mixins;
@use "Styles/includes/variables";

:host {
    display: block;
    background: mixins.get-color(background, bg-black);

    overflow-x: auto;
    padding: 8px;

    @include mixins.desktop-and-up {
        display: none;
    }
}

.vm-chat-mobile-trigger {
    &__suggestions {
        width: max-content;
        display: flex;
        gap: 8px;
        align-items: center;
        color: mixins.get-color(background, bg-white);
    }
    // Placeholder pills for the dynamic questions. Matched to the `sm` vm-button box
    // (36px tall, 8px radius, 12px side padding) so the swap to real questions doesn't
    // shift the strip.
    &__skeleton {
        @include mixins.skeleton-block(mixins.get-color(background, bg-white));
        flex: 0 0 auto;
        height: 36px;
        border-radius: 8px;

        width: 400px;

        &:nth-of-type(2) {
            width: 350px;
        }

        &:nth-of-type(3) {
            width: 450px;
        }
    }

    &__suggestion {
        &::part(button) {
            font-family: variables.$fontQuaternary;
            border: none;
            text-align: left;
            border-radius: 8px;
            background-color: mixins.get-color(brand-alert, components, table, data, strong);
            color: mixins.get-color(background, bg-white);
            font-weight: 500;
            letter-spacing: 0.07px;
        }

        // Lift the anchored button above `.shepherd-modal-overlay-container`. Shadow DOM
        // doesn't create a stacking context, so this competes with the overlay directly.
        &.shepherd-target.shepherd-enabled {
            position: relative;
            z-index: mixins.get-z(product-tour, dialog);
        }

        &.shepherd-target.shepherd-enabled::part(button) {
            border: 3px solid transparent;
            background:
                linear-gradient(mixins.get-color(brand-alert, components, table, data, strong) 0 0) padding-box,
                linear-gradient(to right, mixins.get-color(teal, 600), #4d56ca) border-box;
            line-height: 14px;
        }
    }
}
